import api from "../../api";
import { useEffect, useState } from 'react'
import styles from './style.module.css'
import TagsCheckboxGroup from "../../components/tags-checkbox-group";
import { useTags } from "../../components/utils/use-tags";
import NewsCardList from "../../components/news-card-list";
import NewsCard from "../../components/news-card";
import Title from "../../components/title";
import Pagination from "../../components/pagination";
import { Breadcrumbs, PreLoader } from "../../components";


const News = () => {
    const [loading, setLoading] = useState(false);
    const { value: tagsValue, handleChange: handleTagsChange, setValue: setTagsValue } = useTags()
    const [newsPage, setNewsPage] = useState(1)
    const [newsList, setNewsList] = useState([])
    const [newsCount, setNewsCount] = useState(0)

    const titleName = 'Новости'

    const getNews = ({ page = 1, tags }) => {
        setLoading(true);
        api.getNews({ page, tags })
            .then(res => {
                setLoading(false);
                const { count } = res
                setNewsList(res)
                setNewsCount(count)
            })
    }

    useEffect(_ => {
        getNews({ page: newsPage, tags: tagsValue })
    }, [newsPage, tagsValue])

    useEffect(_ => {
        api.getTags()
            .then(tags => {
                setTagsValue(tags.results?.map(tag => ({ ...tag, value: true })))
            })
    }, []);

    return (
        <>
            <div className={styles.news_area}>
                {loading ? (
                    <PreLoader />
                ) : (
                    <>
                        <Title title={titleName} />
                        <Breadcrumbs urls={[{ title: titleName, path: '' }]} />
                        <div className={styles.news__row}>
                            <NewsCardList>
                                {newsList.results?.map(card => <NewsCard
                                    {...card}
                                    key={card.id}
                                />)}
                            </NewsCardList>
                            <div className={styles.news__categories}>
                                <div className={styles.news__categories__title}>Категории</div>
                                <div className={styles.news__categories__name}>
                                    <div className={styles.news__categories__item}>
                                        <TagsCheckboxGroup
                                            newsList={newsList}
                                            values={tagsValue}
                                            handleChange={value => {
                                                handleTagsChange(value)
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <Pagination
                                count={newsCount / 10}
                                limit={1}
                                page={newsPage}
                                onPageChange={page => setNewsPage(page)}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export default News;